import { render } from "./listeRegime.vue?vue&type=template&id=4d551abc"
import script from "./listeRegime.vue?vue&type=script&lang=js"
export * from "./listeRegime.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__